/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_NotificationService_DTOs_BellNotificationDto } from '../models/Wealthlane_NotificationService_DTOs_BellNotificationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NotificationSharedService {

    /**
     * @returns Wealthlane_NotificationService_DTOs_BellNotificationDto OK
     * @throws ApiError
     */
    public static getApiNotificationApiAppNotificationNotifications(): CancelablePromise<Array<Wealthlane_NotificationService_DTOs_BellNotificationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/api/app/notification/notifications',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns number OK
     * @throws ApiError
     */
    public static getApiNotificationApiAppNotificationUnseenNotificationsCount(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/notification/api/app/notification/unseen-notifications-count',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
